import { normalizeAxiosError } from '@/lib/error';

/**
 * Runs an axiosInstance call and returns the response body. Rejects with the
 * `{ error: { code, message, … } }` envelope, so `displayError` and
 * `err.error.message` work for every hook built on it.
 */
export const request = async <T>(call: () => Promise<{ data: T }>): Promise<T> => {
  try {
    const { data } = await call();
    return data;
  } catch (error) {
    throw normalizeAxiosError(error);
  }
};
